<div class="container m-t-10 m-b-10" id="status-container">
    <div class="header d-flex align-items-center justify-content-between">
        <div class="header-text">
            <h4>{{title}}</h4>
        </div>
        <button class="buttons close-icon d-flex align-items-center justify-content-center" type="button"
            (click)="closeDialog()" aria-label="Close">
            <span aria-hidden="true" style="font-size: 32px; line-height: 1;">&times;</span>
        </button>
    </div>

    <!-- Scrollable Popup Content -->
    <div class="scrollbar scrollable-content custom-scroll">
        <div [innerHTML]="popupcontent"></div>
    </div>

</div>